import Snackbar from 'material-ui/Snackbar/Snackbar';

export default Snackbar;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Snackbar/index.ts